<template>
  <b-modal id="reopen-testinput" ref="reopen-testinput" centered hide-footer title="Mở chấm lại" size="ms">
    <p>
        Sau khi mở chấm lại, admin có thể vào lại tác vụ để chấm bài. Kết quả mới sẽ được thay thế tại phiếu điểm sau khi bài test được chấm lại
    </p>
    <div class="d-flex justify-content-end mt-6">
          <button type="button" class="btn btn-secondary" @click="cancel()">Hủy bỏ</button>
          <button type="button" class="btn btn-info ml-3" :disabled="loading" @click="submit()"><i class="el-icon-loading" v-if="loading"></i> Xác nhận</button>
    </div>

  </b-modal>

</template>
<script>
import { TEST_INPUT_REOPEN } from '../../../../../core/services/store/test/testInput.module';

export default{
    name: "ModalReOpenTestInput",
    data() {
        return {
            loading : false
        }
    },
    props: {
      informationTask: {
        type: Object,
        default(){
          return {}
        }
      },
    },
    methods : {
      cancel(){
        this.$bvModal.hide('reopen-testinput')
      },
      async submit() {
        try{
          this.loading= true;
          const data = await this.$store.dispatch(TEST_INPUT_REOPEN,this.informationTask.taskCode );
          this.$bvModal.hide('reopen-testinput')
          this.$message({
            message: 'Xử lý thành công',
            type: 'success'
          });   
          this.$emit('reload')    
        }catch(ex) {
          console.log(ex)
          this.$message({
            message: 'Đã có lỗi xảy ra',
            type: 'error'
          });  
        }finally{
          this.loading = false;
        }
      }
    }
}

</script>

<style scoped>

</style>